<script lang="ts" setup>
import { SearchLgIcon } from '@gohighlevel/ghl-icons/24/outline'
import { UIInput } from '@gohighlevel/ghl-ui'
import { ref, watch } from 'vue'

// Define props
const props = defineProps({
  searchText: String,
  onSearch: Function,
  placeholder: {
    type: String,
    default: 'Search',
  },
  id: String,
})

const searchText = ref(props.searchText)

watch(searchText, newValue => {
  props.onSearch?.(newValue)
})
watch(
  () => props.searchText,
  newValue => {
    searchText.value = newValue || ''
  }
)
</script>

<template>
  <div class="w-[200px]">
    <UIInput
      :id="props.id + '-services-query-search'"
      v-model="searchText"
      :placeholder="props.placeholder"
      clearable
      :style="{ padding: '1px 0px !important' }"
      size="medium"
    >
      <template #prefix>
        <SearchLgIcon class="h-4 w-4 text-gray-500" />
      </template>
    </UIInput>
  </div>
</template>
